import { Injectable, inject } from '@angular/core';

import { Logger, WINDOW } from '@frontend/vanilla/core';

import { ChatRequest } from '../models/models';

@Injectable({
    providedIn: 'root',
})
export class SprinklrChatService {
    private readonly windowRef = inject(WINDOW);
    private sprinklrInitialized = false;
    private logger = inject(Logger);
    openLiveChat(websiteUrl?: string) {
        (this.windowRef as any)?.entainsprinklr?.openChat(websiteUrl);
    }

    public initializeSprinklrChat(chatRequest: ChatRequest, module: string = '') {
        const sdk = (this.windowRef as any).entainsprinklr;
        if (sdk?.setInitData) {
            const isQuickDeposit = ['qd-app', 'betslip-app'].includes(module);
            const sprChatSettings = {
                ...chatRequest,
                isCashier: true,
                action: 'initiatesprinklr',
                isFromQD: isQuickDeposit,
                pageUrl: this.windowRef.location.href,
            };
            sdk.defaultDataSetup(sprChatSettings);
            this.sprinklrInitialized = true;
            this.logger.info('Sprinklr chat initialized.');
        } else {
            this.logger.warn('Sprinklr SDK not available after script load.');
        }
    }
    public isSprinklrInitialized(): boolean {
        return this.sprinklrInitialized;
    }
}
